import { CubeIcon, IconBox } from "@hightouch/htui";
import type { SchemaIconProps } from "./types";

export const ParentIcon = ({ size = "xl", ...props }: SchemaIconProps) => {
  return <IconBox color="indigo" icon={<CubeIcon />} size={size} {...props} />;
};
